<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
      @if (Model.Suspended) {
        <actionbutton Icon="check" ButtonType="warning"
        (PerformAction)="UnsuspendPermit()">Unsuspend Permit</actionbutton>
      }
      @if (!Model.Suspended) {
        <actionbutton Icon="ban" ButtonType="danger"
        (PerformAction)="SuspendPermit()">Suspend Permit</actionbutton>
      }
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Permit Details
          </p>
          <div class="panel-block">
            <span class="label">Id</span>
            <span class="value">{{Model.Id}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Permit Type</span>
            <span class="value"><a
              href="permits/permittypes/{{Model.ParkingPermitTypeId}}">{{Model.ParkingPermitTypeName}}
            ({{Model.ParkingPermitTypePriceString}})</a></span>
          </div>
          <div class="panel-block">
            <span class="label">Active Dates</span>
            <span class="value"><app-daterangedisplay FieldName="Active Dates"
              [StartDate]="Model.StartDateLocalFriendlyString"
            [EndDate]="Model.EndDateLocalFriendlyString"></app-daterangedisplay></span>
          </div>
          <div class="panel-block">
            <span class="label">Status</span>
            <span class="value">{{Model.CurrentStateName || Model.CurrentStateKey}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Times used</span>
            <span class="value">{{Model.ParkingPermitInstanceCount}}</span>
          </div>
          @if (Model.ParkingSpaceId != null) {
            <div class="panel-block">
              <span class="label">Assigned Parking Space</span>
              <span class="value">
                <div class="field is-grouped is-grouped-multiline">
                  <div class="tags has-addons">
                    <a class="tag">{{Model.ParkingSpaceLocationString}}</a>
                  </div>
                </div>
              </span>
            </div>
          }
          <!-- Single User Permit -->
          @if (isSingleUserPermit()) {
            <div class="panel-block">
              <span class="label">User</span>
              <span class="value">{{Model.FullName}}</span>
            </div>
          }
          @if (isSingleUserPermit()) {
            <div class="panel-block">
              <span class="label">Last Paid On</span>
              <span class="value">{{Model.LastPaidOnLocalFriendlyString}}</span>
            </div>
          }
          @if (isSingleUserPermit()) {
            <div class="panel-block">
              <span class="label">Next Renewal Due</span>
              <span class="value">{{Model.NextRenewalDueLocalFriendlyString}}</span>
            </div>
          }
          @if (isSingleUserPermit()) {
            <div class="panel-block">
              <span class="label">Automatic Charge Enabled</span>
              <span class="value">{{Model.AutomaticChargeEnabled ? 'Yes' : 'No'}}</span>
            </div>
          }
          @if (isSingleUserPermit() && Model.CancelOnRenew) {
            <div class="panel-block">
              <span class="label">Cancel On Renew</span>
              <span class="value">{{Model.CancelOnRenew ? 'Yes' : 'No'}}</span>
            </div>
          }
          <!-- Multi User Permit -->
          @if (isMultiUserPermit()) {
            <div class="panel-block">
              <span class="label">Total Users</span>
              <span class="value">{{Model.TotalUsersCount}}</span>
            </div>
          }
          @if (isMultiUserPermit()) {
            <div class="panel-block">
              <span class="label">Active Users</span>
              <span class="value">{{Model.ActiveParkingPermitUsers}}</span>
            </div>
          }
          @if (isMultiUserPermit()) {
            <div class="panel-block">
              <span class="label">Invited Users</span>
              <span class="value">{{Model.InvitedParkingPermitUsers}}</span>
            </div>
          }
          @if (isMultiUserPermit()) {
            <div class="panel-block">
              <span class="label">Permit Users</span>
              <span class="value">
                <div class="field is-grouped is-grouped-multiline">
                  @for (u of Model.ParkingPermitUsers; track u; let i = $index) {
                    <div class="control">
                      <div class="tags has-addons">
                        <a class="tag">{{u.FirstName}} {{u.LastName}} ({{u.Email}})</a>
                        @if (u.IsPurchaser) {
                          <a class="tag is-dark">Owner</a>
                        }
                        <a class="tag is-info">{{u.CurrentStateKey}}</a>
                      </div>
                    </div>
                  }
                </div>
              </span>
            </div>
          }
        </article>
      </div>
      <div class="column is-6 image-container">
        <img src="../../../../../assets/images/permitimage.svg" alt="FrogOne Parking Permits" />
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <article class="panel">
          <p class="panel-heading">
            Usage Instances
          </p>
          <app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl='permits/{{Model.Id}}/instances/searches'
            [AllowEdit]="false" [ShowPaging]="true" [EditUrlPerItem]="true" [AllowCustomAction]="true"
          [CustomAction]="CustomAction"></app-datalistview>
        </article>
      </div>
    </div>
  </div>
}